import React, { memo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { reduxBatch } from '@manaflair/redux-batch'
import { getEditedJob, getJobInputs, selectIds, getResultState } from '../../store/selectors'
import { getSelectedRow, jobSettingsActions, resultActions } from '../../store/slices'

import { RenderIf, getLatestJobId, getModelImage, prepareJobData } from '../../common/fns'

import { DuplicateJobError } from '..'

import { jobsActions } from '../../store/slices/jobTally'
import { useModal } from '../../../../utils/hooks'

const JobStatus = () => {
  const dispatch = useDispatch()
  const jobIds = useSelector(selectIds)
  const editedJob = useSelector(getEditedJob)
  const jobInputs = useSelector(getJobInputs)
  const selectedRow = useSelector(getSelectedRow)
  const renderedData = useSelector((state) => getResultState(state).renderedData)

  const [show, toggle] = useModal(false)

  const handleCancelEdit = () => {
    const jobId = getLatestJobId(jobIds.length)

    reduxBatch([
      dispatch(jobSettingsActions.updateInput({ jobID: jobId })),
      dispatch(jobsActions.setEditedJob(null)),
      dispatch(resultActions.setSelectedRow()),
    ])
  }

  const handleSaveChanges = async () => {
    if (selectedRow) {
      // Remove UID of first time edit to avoid overwrite
      const { jobID: newJobID } = jobInputs.jobSettings
      const currentJobID = editedJob.uid

      if (currentJobID !== newJobID && jobIds.includes(newJobID)) {
        toggle()
      } else {
        const updatedJob = prepareJobData(jobInputs, selectedRow)
        updatedJob.modelImg = await getModelImage()
        updatedJob.outputData = renderedData
        const jobId = getLatestJobId(jobIds.length)

        reduxBatch([
          dispatch(jobsActions.jobUpdated({ id: currentJobID, changes: updatedJob })),
          dispatch(jobsActions.setEditedJob(null)),
          dispatch(jobSettingsActions.modifyInput({ name: 'jobID', value: jobId })),
          dispatch(resultActions.setSelectedRow()),
        ])
      }
    }
  }

  return RenderIf(
    editedJob,
    <div className="job-status-container">
      <div className="job-status-container__content">
        <span>{`Editing ${editedJob?.uid}`}</span>
      </div>
      <div className="job-status-container__actions">
        <button onClick={handleSaveChanges} disabled={!selectedRow}>
          <span>Save changes</span>
        </button>
        <button onClick={handleCancelEdit}>
          <span>Cancel</span>
        </button>
      </div>

      <DuplicateJobError show={show} toggle={toggle} />
    </div>,
  )
}

export default memo(JobStatus)
